<section class="notifications-slide" *ngIf="loading || notifications.length > 0">
  <nz-spin [nzSpinning]="loading">
    <nz-carousel
      [nzAutoHeight]="true"
      [nzAutoPlay]="true"
      [nzAutoPlaySpeed]="5000"
      nzEffect="scrollx"
      [nzDots]="true"
      class="notifications-slide__carousel">
      <div
        nz-carousel-content
        class="notifications-slide__slide"
        *ngFor="let item of notifications; trackBy: trackByNotificationId">
        <article
          class="notification-slide-card"
          (click)="openDetail(item, $event)"
          (keydown.enter)="openDetail(item, $event)"
          tabindex="0"
          role="button">
          <div class="notification-slide-card__header">
            <div class="notification-slide-card__eyebrow">
              <span nz-icon nzType="sound" nzTheme="fill"></span>
              {{ 'dashboard.latestAnnouncements' | translate }}
            </div>
            <a
              routerLink="/announcements"
              class="notifications-slide__all-link"
              (click)="$event.stopPropagation()">
              <span>{{ 'dashboard.allAnnouncements' | translate }}</span>
              <span nz-icon nzType="right" nzTheme="outline"></span>
            </a>
          </div>

          <h3 class="notification-slide-card__title">{{ item.title }}</h3>
          <p class="notification-slide-card__content">
            <span *ngIf="item.content">{{ item.content | notificationPreview: 160 }}</span><a
              class="notification-slide-card__detail-link"> {{ 'dashboard.viewDetails' | translate }}</a>
          </p>
        </article>
      </div>
    </nz-carousel>
  </nz-spin>
</section>

<app-notification-detail-modal
  [(visible)]="detailVisible"
  [notification]="selectedNotification"
  (visibleChange)="!$event && closeDetail()">
</app-notification-detail-modal>
